import { z } from "zod";

/** The longest note the server accepts, in characters. `NetworkConnectionNote.MaximumBodyLength`. */
export const MAXIMUM_NETWORK_CONNECTION_NOTE_LENGTH = 2000;

/** The caller's own private note on one of their network connections (#1209). */
export const NetworkConnectionNoteSchema = z.object({
  connectionId: z.uuid(),
  body: z.string(),
  updatedDate: z.iso.datetime({ offset: true }),
});

export type NetworkConnectionNoteJSON = z.infer<typeof NetworkConnectionNoteSchema>;
